
import {
  loadPostscriptSdk,
  openPostscriptPopup,
  waitForPostscriptSdk
} from '@/modules/PostscriptSdk'

export default {
  name: 'PostscriptPopup',
  props: {
    blok: {
      required: true,
      type: Object
    }
  },
  mounted() {
    if (!process.browser) return

    const popupId = this.blok.popup_id
    if (!popupId) {
      // eslint-disable-next-line no-console
      console.warn('PostscriptPopup: missing popup_id; skipping popup trigger.')
      return
    }

    const shopId = this.$config.postscriptShopId
    if (!shopId) {
      // eslint-disable-next-line no-console
      console.warn(
        'PostscriptPopup: missing $config.postscriptShopId (POSTSCRIPT_SHOP_ID env var); skipping popup trigger.'
      )
      return
    }

    loadPostscriptSdk(shopId)
      .then(() => waitForPostscriptSdk())
      .then(() => openPostscriptPopup(popupId))
      .catch(err => {
        // eslint-disable-next-line no-console
        console.warn(err && err.message ? err.message : err)
      })
  }
}
